import { FC, useCallback } from "react";
import useForm from "../../../hooks/useForm";
import { FormGroup } from "../../../components/forms";
import TextInput from "../../../components/form-fields/TextInput";
import { removeExtraSpaces } from "../../../helpers/shared/formHandlers";
import { LoadingButton } from "../../../components/basics/Button";
import { ButtonType } from "../../../helpers/shared/buttonStyling";
import { CreatePolicyType } from "./type";
import { policyDetailsValidations } from "../../../helpers/travel/payNowValidations";

interface PolicyDetailsProps {
  t: any;
  state: CreatePolicyType;
  setState: any;
  disabled?: boolean;
  onSubmit?: any;
  submitting?: any;
}

const PolicyDetails: FC<PolicyDetailsProps> = ({ state, t, setState, disabled, onSubmit, submitting }) => {
  const onFieldChange = useCallback(
    (key: keyof typeof state, value: string | number | Date | null) => {
      setState((prevState: any) => ({ ...prevState, [key]: value }));
    },
    [setState]
  );

  const { field, validateField, validateForm } = useForm(state, policyDetailsValidations, onFieldChange);
  const handleSubmit = () => validateForm(onSubmit);
  return (
    <div>
      <FormGroup title={t("insuredName")}>
        <TextInput
          label={t("insuredName")}
          {...field.insuredName}
          aria-label="insured-name"
          value={state.insuredName}
          onBlur={removeExtraSpaces("insuredName", setState, validateField)}
          disabled={disabled}
        />
      </FormGroup>
      <FormGroup title={t("policyNo")}>
        <TextInput
          label={t("policyNo")}
          aria-label="policy-number"
          {...field.policyNumber}
          value={state.policyNumber}
          onBlur={removeExtraSpaces("policyNumber", setState, validateField)}
          disabled={disabled}
        />
      </FormGroup>
      <FormGroup title={t("contactNo")}>
        <TextInput
          {...field.contactNumber}
          aria-label="contact-no"
          label={t("contactNo")}
          value={state.contactNumber}
          onBlur={removeExtraSpaces("contactNumber", setState, validateField)}
          disabled={disabled}
        />
      </FormGroup>
      <FormGroup title={t("email")} subtitle={t("emailSubtitle")}>
        <TextInput
          label={t("email")}
          aria-label="email"
          {...field.email}
          value={state.email}
          onBlur={removeExtraSpaces("email", setState, validateField)}
        />
      </FormGroup>
      <FormGroup className="!mt-4 mb-16" title={t("amount")}>
        <TextInput
          label={t("amount")}
          aria-label="amount"
          {...field.amount}
          value={state.amount}
          onBlur={removeExtraSpaces("amount", setState, validateField)}
          disabled={disabled}
        />
      </FormGroup>
      <div className="md:flex items-center justify-between py-8">
        <div></div>
        <div className="xs:w-[329px] md:w-[280px]">
          <LoadingButton type={ButtonType.PRIMARY} onClick={handleSubmit} isLoading={submitting} loadingText={"Submitting"}>
            {"Pay"}
          </LoadingButton>
        </div>
      </div>
    </div>
  );
};

export default PolicyDetails;
